(function() {
	'use strict';

	angular.module('claimsApp').controller('ClaimAdjustInfoGAMCancelDialogController',
			ClaimAdjustInfoGAMCancelDialogController);

	ClaimAdjustInfoGAMCancelDialogController.$inject = [ '$scope', '$state', '$log','ClaimAdjustInfo','$stateParams','claimCase','$uibModalInstance' ];

	function ClaimAdjustInfoGAMCancelDialogController($scope, $state, $log,ClaimAdjustInfo,$stateParams,claimCase,$uibModalInstance) {
		var param = $stateParams;
		
		var claimAdjustInfoCancelDialogCtrl = this;
		
		ClaimAdjustInfo.getReasonCancel({},function(result){
			claimAdjustInfoCancelDialogCtrl.reasons = result;
		});
		
		claimAdjustInfoCancelDialogCtrl.cancel = function() {
	    	    $uibModalInstance.dismiss('cancel');
	    };
	    
	    claimAdjustInfoCancelDialogCtrl.submit = function (){
	    	var data = {
	    		cancelCode:claimAdjustInfoCancelDialogCtrl.cancelCode,
	    		taskInstanceId:claimCase.taskInstanceId,
	    		claimAdjustInfoId: claimCase.claimAdjustInfoId,
	    		txnId:claimCase.transactionId
	    	}
	    	ClaimAdjustInfo.cancelCase(data,function(result){
	    		 $uibModalInstance.close(claimCase);
	    	});
	    }
	}
})();
